var Address = function (Properties = null) {
  Properties.AddressID ? this.AddressID = Properties.AddressID : this.AddressID = this.__proto__.AddressID;
  Properties.CompanyName ? this.CompanyName = Properties.CompanyName : this.CompanyName = this.__proto__.CompanyName;
  Properties.Street ? this.Street = Properties.Street : this.Street = this.__proto__.Street;
  Properties.Number ? this.Number = Properties.Number : this.Number = this.__proto__.Number;
  Properties.PostalCode ? this.PostalCode = Properties.PostalCode : this.PostalCode = this.__proto__.PostalCode;
  Properties.City ? this.City = Properties.City : this.City = this.__proto__.City;
  Properties.Country ? this.Country = Properties.Country : this.Country = this.__proto__.Country;
  Properties.MoreInformation ? this.MoreInformation = Properties.MoreInformation : this.MoreInformation = this.__proto__.MoreInformation;
  Properties.AddressLine2 ? this.AddressLine2 = Properties.AddressLine2 : this.AddressLine2 = this.__proto__.AddressLine2;
};

Address.prototype = {
  AddressID: null,
  CompanyName: '',
  Street: '',
  Number: null,
  PostalCode: null,
  City: '',
  Country: null,
  MoreInformation: '',
  AddressLine2: '',
};

export default Address;
